import { Redirect, Slot } from 'expo-router'
import { ActivityIndicator } from 'react-native'

import { useCommunityQuery } from '@/src/features/community/services/useCommunityQuery'
import { useCommunityJoinSearchParams } from '@/src/features/community/ui/hooks/useCommunityJoinSearchParams'
import { useFraternityJoinPublicationPrefs } from '@/src/features/fraternity/ui/hooks/useFraternityJoinPublicationPrefs'
import { useRoutes } from '@/src/general/utils/routes'

export default function CommunityJoinSubscribedOnlyLayout() {
  const { idSlug } = useCommunityJoinSearchParams()
  const { routes } = useRoutes()

  // Safely extract and validate the community ID
  const id = idSlug ? parseInt(idSlug.split('-')[0], 10) : null
  const isValidId = id !== null && !isNaN(id) && id > 0

  const { data: community, isPending } = useCommunityQuery(id)
  useFraternityJoinPublicationPrefs(community)
  if (!isValidId) return <Redirect href={routes.communities()} />

  // Show loading if we're waiting for a valid query
  if (isPending && isValidId) {
    return <ActivityIndicator size="large" className="self-center mt-10" />
  }

  return <Slot />
}
